import styled from "styled-components";
import { Select } from '../../../components/ui';

export const SelectContainer = styled.div`
  & select{
    display: none !important;
  }
`